
import React from 'react';
import { Package, Archive, Wheat, Apple, Milk, Fish, Beef, Soup, Coffee, Wine, ShoppingBasket, Cookie, Salad, Pizza, Droplets } from 'lucide-react';

interface SubCategoryIconProps {
  sousCategorie: string | null;
  className?: string;
}

const SubCategoryIcon = ({ sousCategorie, className = "h-3 w-3 text-nautic" }: SubCategoryIconProps) => {
  const getSousCategorieIcon = (sousCategorie: string | null) => {
    if (!sousCategorie) return Package;
    
    switch (sousCategorie.toLowerCase()) {
      case 'conserves':
        return Archive;
      case 'pâtes':
      case 'riz':
      case 'céréales':
      case 'pain et céréales':
        return Wheat;
      case 'fruits frais':
      case 'légumes frais':
        return Apple;
      case 'produits laitiers':
        return Milk;
      case 'fromages':
        return ShoppingBasket;
      case 'boissons':
      case 'eau':
        return Droplets;
      case 'viandes':
      case 'charcuterie':
        return Beef;
      case 'poissons':
      case 'fruits de mer':
        return Fish;
      case 'soupes':
      case 'plats préparés':
        return Soup;
      case 'café':
      case 'thé':
        return Coffee;
      case 'alcools':
      case 'vins':
        return Wine;
      case 'boulangerie':
      case 'pain':
        return ShoppingBasket;
      case 'confiseries':
      case 'chocolats':
        return Package;
      case 'biscuits':
      case 'gâteaux':
        return Cookie;
      case 'condiments':
      case 'épices':
        return Salad;
      case 'pizza':
        return Pizza;
      default:
        return Package;
    }
  };

  const Icon = getSousCategorieIcon(sousCategorie);
  return <Icon className={className} />;
};

export default SubCategoryIcon;
